import { configureStore } from "@reduxjs/toolkit";
 import localizationReducer from "./Localization";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import authRducer from "./auth";
import schoolsReducer from "./Schools";
import stagesReducer from "./stages";
import classesReducer from "./Classes";
import expensesReducer from "./expenses";
import studentsReducer from "./students";
import registerStudentsReducer from "./registerStudents";

const persistConfig = {
	key: "root",
	version: 1,
	storage,
};

const RootReducers = combineReducers({
	auth: authRducer,
currentLocal: localizationReducer,
schools:schoolsReducer,
stages:stagesReducer,
classes:classesReducer,
expenses:expensesReducer,
Students:studentsReducer,
registerStudents:registerStudentsReducer



});

const persistedReducer = persistReducer(persistConfig, RootReducers);

export default configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
});